import BogglerTrailsPage from './components/boggler-trails-page';
import './index.css';

export default function App() {
  return <BogglerTrailsPage />;
}
